/**
 * PATH: packages/ui/src/kanban/components/kanbanCardThreadSupport.ts
 * FILE_ID: UI-KANBAN-CARD-THREAD-001
 * PURPOSE: Determine which conversation surface a card can open.
 * WHY: Thread stays direct on phones only when a supported conversation exists.
 * FLOW: Card/API capabilities → AI/comment support flags → control decision.
 * RELATED: KanbanCardInteractionControls.tsx; KanbanCard.tsx.
 */
import type { KanbanCardProps } from './KanbanCard.types'

export interface KanbanCardThreadSupport {
  hasAiThread: boolean
  canShowThread: boolean
}

export function getKanbanCardThreadSupport(
  card: KanbanCardProps['card'],
  api: KanbanCardProps['api'],
): KanbanCardThreadSupport {
  const hasAiThread =
    !!api?.getCardAiThread &&
    (!!card.primary_email ||
      (card.related_email_count ?? card.related_emails?.length ?? 0) > 0)
  const hasComments =
    !!api?.listComments && !!api?.createComment && !!api?.deleteComment

  return {
    hasAiThread,
    canShowThread: hasAiThread || hasComments,
  }
}
